import React from 'react';
import { Check, CheckCircle2 } from 'lucide-react';
export function BeneficiosIdeal() {
  return <section id="beneficios" className="py-8 sm:py-14 bg-[#0a0a0a]" data-id="element-14">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8" data-id="element-16">
          <div className="bg-[#141414] p-4 sm:p-6 rounded-xl border border-gray-800" data-id="element-17">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-3 sm:mb-5 border-b border-gray-800 pb-2 sm:pb-3" data-id="element-18">
              Este kit es ideal para:
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-19">
              {['Docentes de Geografía de secundaria', 'Profesores que trabajan en varias instituciones', 'Docentes que quieren orden y estructura anual', 'Educadores que buscan material listo para usar', 'Estudiantes de profesorado'].map((item, index) => <li key={index} className="flex items-start" data-id="element-20">
                  <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-21">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-22" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-300" data-id="element-23">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-[#141414] p-4 sm:p-6 rounded-xl border border-gray-800" data-id="element-24">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-3 sm:mb-5 border-b border-gray-800 pb-2 sm:pb-3" data-id="element-25">
              Beneficios del Kit
            </h3>
            <ul className="space-y-2 sm:space-y-3" data-id="element-26">
              {['Material actualizado y organizado por ejes centrales', 'Recursos aplicables directamente en clase', 'Contenido adaptable a distintos diseños curriculares provinciales', 'Enfoque pedagógico claro y estructurado', 'Ahorro enorme comprando el sistema completo'].map((item, index) => <li key={index} className="flex items-start" data-id="element-27">
                  <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 sm:p-1 mr-2 mt-0.5" data-id="element-28">
                    <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-29" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-300 font-medium" data-id="element-30">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}